/** 消息 Tab · 会话列表（微信首 Tab 风格） */
export const SPACE_MESSAGES = {
  avatarSize: 48,
  /** 行左右内边距（px） */
  rowPaddingX: 16,
  /** 头像与右侧文案区间距（px） */
  rowGap: 12,
  nameFontSize: 16,
  nameColor: "#191919",
  previewFontSize: 14,
  previewColor: "#999999",
  timeFontSize: 12,
  timeColor: "#b2b2b2",
  /** 会话行之间分割线颜色 */
  dividerColor: "rgb(249, 249, 249)",
  badgeBg: "#fa5151",
  badgeColor: "#ffffff",
  badgeFontSize: 11,
  emptyColor: "#999999",
  /**
   * 会话名称行（含右侧时间）相对头像顶部水平线的下移距离（px）。
   * 行内头像顶对齐；调大则名称整体下移。
   */
  nameOffsetFromAvatarTop: 0,
  /**
   * 最新消息缩略相对会话名称行的间距（px）。
   */
  previewGapFromName: 2,
  /**
   * 会话行上下内边距（px）；调大则相邻行之间更疏。
   */
  rowSpacing: 6,
  /**
   * 整个会话列表顶部内边距（px）；在安全区补偿之外再叠加。
   */
  listPaddingTop: 10,
} as const;
